import client from "./clients/portalClient";

const getAllGms = () => client.get(`/gm_dashboard`);
const gmApi = {
    getAllGms,
};

export default gmApi;
